import axios from 'axios';
import { basicAuthConfig } from '../configs';
import { urlMyspreadApi } from '../urls';

// Obtener vehículos paginados y filtrados
export const getVehiculos = async (user, params = {}) => {
  try {
    const config = basicAuthConfig(user);
    let endpoint = urlMyspreadApi.replace(/\/$/, '') + '/mantenedores/vehiculos/?';
    const query = [];

    query.push(`pageSize=${params.pageSize || 10}`);
    query.push(`pageNumber=${params.pageNumber || 1}`);

    if (params.tipo_vehiculo_id) query.push(`tipo_vehiculo_id=${params.tipo_vehiculo_id}`);
    if (params.searchValue) query.push(`searchValue=${encodeURIComponent(params.searchValue)}`);

    endpoint += query.join('&');
    const response = await axios.get(endpoint, config);

    if (response.data) {
      return {
        success: true,
        data: response.data.data || [],
        total: response.data.total || 0,
        message: response.data.message
      };
    }

    return { success: false, data: [], total: 0, error: 'No data' };
  } catch (error) {
    console.error('Error al obtener vehiculos:', error);
    return { success: false, data: [], total: 0, error: error.response?.data?.message || 'Error' };
  }
};

// Obtener vehículo por id
export const getVehiculoById = async (user, vehiculoId) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/vehiculos/${vehiculoId}`;
    const response = await axios.get(endpoint, config);
    if (response.data) {
      return { success: true, data: response.data.data || null, message: response.data.message };
    }
    return { success: false, data: null, error: 'No data' };
  } catch (error) {
    console.error('Error al obtener vehiculo:', error);
    return { success: false, data: null, error: error.response?.data?.message || 'Error' };
  }
};

// Crear vehículo
export const createVehiculo = async (user, body) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/vehiculos/`;
    const response = await axios.post(endpoint, body, config);
    if (response.data) {
      return { success: true, data: response.data.data || {}, message: response.data.message };
    }
    return { success: false, error: 'No data' };
  } catch (error) {
    console.error('Error al crear vehiculo:', error);
    return { success: false, error: error.response?.data?.message || 'Error' };
  }
};

// Actualizar vehículo
export const updateVehiculo = async (user, vehiculoId, body) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/vehiculos/${vehiculoId}`;
    console.log('Updating vehicle at endpoint:', endpoint, 'with body:', body);
    const response = await axios.put(endpoint, body, config);
    if (response.data) {
      return { success: true, data: response.data.data || {}, message: response.data.message };
    }
    return { success: false, error: 'No data' };
  } catch (error) {
    console.error('Error al actualizar vehiculo:', error);
    return { success: false, error: error.response?.data?.message || 'Error' };
  }
};

// Tipos de vehiculos
export const getTiposVehiculo = async (user) => {
  try {
    const config = basicAuthConfig(user);
    const endpoint = `${urlMyspreadApi.replace(/\/$/, '')}/mantenedores/vehiculos/tipos`;
    const response = await axios.get(endpoint, config);
    if (response.data) {
      return { success: true, data: response.data.data || [], total: response.data.total || 0, message: response.data.message };
    }
    return { success: false, data: [], total: 0, error: 'No data' };
  } catch (error) {
    console.error('Error al obtener tipos de vehiculo:', error);
    return { success: false, data: [], total: 0, error: error.response?.data?.message || 'Error' };
  }
};
